module.exports = __webpack_public_path__ + "static/media/crayondoodle3.81eaf46d.pdf";